'use client';
import { FiCreditCard } from 'react-icons/fi';

import Button from '@/components/@base/button';
import Container from '@/components/@base/container';
import { Text } from '@/components/@base/typography';
import XImage from '@/components/@base/x-image';
import Auth from '@/components/app/auth/components';
import { useGetProfile } from '@/components/layout/services/hooks';

import useCommonModalStore from '@/store/common-modal-store';

import ICON_SIZE, { ICON_COLOR } from '@/constant/icon-size-color';
import imagesList from '@/constant/images-list';
import localization, { pageLevelLocalization } from '@/constant/localization';

const { cart: cartLocalization } = pageLevelLocalization;
export default function Header() {
  const { setShow } = useCommonModalStore();
  const { isAuthenticated } = useGetProfile();

  const handleAuthModal = () => {
    setShow(true, {
      DialogPanelProps: { className: 'rounded-xl overflow-hidden shadow-none!  p-0! bg-transparent!' },
      Body() {
        return <Auth />;
      },
    });
  };

  return (
    <Container
      center
      className='justify-between md:border-b-[1px] md:border-b-[#EFEFF2] md:p-[26px]'
    >
      <Container center className='gap-[35px]'>
        <Text className='text-[22px] md:text-[18px]'>{localization.cart}</Text>
        <Container center className='hidden gap-[10px] md:flex'>
          <FiCreditCard color={ICON_COLOR.gray} size={ICON_SIZE.sm} />
          <Text className='text-[#878F9B]'>{cartLocalization.easyAccessToPurchase}</Text>
        </Container>
      </Container>

      {!isAuthenticated && (
        <Button
          onClick={handleAuthModal}
          className='h-12 w-[152px] bg-[#F7F8F9] text-[#878F9B]'
          Icon={
            <XImage
              src={imagesList.icons.zhkSmGrayLogo}
              alt={localization.zhaket}
              width={16}
              height={16}
            />
          }
        >
          <Text>{localization.loginToZhaket}</Text>
        </Button>
      )}
    </Container>
  );
}
